import React from "react";
import Action from "../actions";

export function ggRecaptchaReducer(state =
                                       {
                                           recaptcha: '',
                                           refUnauthorized: React.createRef(),
                                           refAuthorized: React.createRef(),
                                           refSplash: React.createRef()
                                       }, action) {
    if (action.type === Action.SET_GG_RECAPTCHA_VALUE) {
        return action.recaptchaValue
    }
    return state;
}
